import React, { useContext, useEffect, useState } from 'react'
import { Button, Form, InputGroup, Nav, Spinner } from 'react-bootstrap'
import filtericon from "../../assets/images/Filter.png";
import DataTable from 'react-data-table-component';
import { RiArrowDownSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { BsThreeDots } from "react-icons/bs";
import { deleteOrderItem, getOrdersListing, getTrackingOrdersListing, updateTrackingStatus } from '../../api/context/orders';
import Loader from '../../components/loader/loader';
import { Box, Paper, Tooltip } from "@mui/material";
import moment from 'moment';
import ordernew from '../../assets/images/order-new.png';
import orderexchange from '../../assets/images/order-exchange.png';
import orderreturn from '../../assets/images/order-return.png';
import deleteIcon from "../../assets/images/delete.svg";
import editIcon from "../../assets/images/edit.svg";
import viewIcon from "../../assets/svg/view.svg";
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { checkUserPermissions } from '../../helpers/permission';
import Select from 'react-select'
import { useFormik } from 'formik'
import Offcanvas from 'react-bootstrap/Offcanvas';
import { orderListFilter, orderListLimit, orderListPage, orderListSearch } from '../../atoms/orderListFilter';
import { useRecoilState } from 'recoil';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { SelectionContext } from '../../Context/Store';
import { IoSearchOutline } from 'react-icons/io5';
import toast from 'react-hot-toast';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { FaDownload } from "react-icons/fa6";
import * as XLSX from 'xlsx';
import Modal from 'react-bootstrap/Modal';

// Extend dayjs with the plugins
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const queueDatatableCustomStyles = {
    headCells: {
        style: {
            display: "flex",
            justifyContent: "center",
            fontWeight: '600',
            fontSize: '14px',
            padding: '16px 8px',
            backgroundColor: '#f9f9f9ff',
        },
    },
    cells: {
        style: {
            display: "flex",
            fontSize: '12px',
            fontWeight: '500',
            padding: '12px',
            zIndex: '5',
            cursor: "pointer"
        },
    },
};

const statusOptions = [
    { value: 'INITIATED', label: 'INITIATED' },
    { value: 'CONFIRMED', label: 'CONFIRMED' },
    { value: 'DELIVERED', label: 'DELIVERED' },
    { value: 'CANCELLED', label: 'CANCELLED' },
    { value: 'REJECTED', label: 'REJECTED' }
];

const deliveryStatusOptions = [
    { value: 'PENDING', label: 'Pending' },
    { value: 'DISPATCHED', label: 'Dispatched' },
    { value: 'DELIVERED', label: 'Delivered' },
    { value: 'CANCELLED', label: 'Cancelled' }
];

const paymentStatusOptions = [
    { value: 'PENDING', label: 'PENDING' },
    { value: 'DONE', label: 'DONE' }
];

const Tracking = () => {
    const navigate = useNavigate()
    const { ordersTrigger, setOrdersTrigger } = useContext(SelectionContext)
    const [filterData, setFilterdata] = useRecoilState(orderListFilter);
    const [orders, setOrders] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [update, setUpdate] = useState(false);
    const [initial, setInitial] = useState(false);
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [filter, setFilter] = useState("completed");
    const [show, setShow] = useState(false);
    const [checkoutErrorShown, setCheckoutErrorShown] = useState(false);
    const [downloadOrdersExcel, setDownloadOrdersExcel] = useState(false);
    const [totalOrdesToDownload, setTotalOrdersToDownload] = useState([]);
    const [limitDownloadOrders, setLimitDownloadOrders] = useState(5);
    const [showTrackingModal, setShowTrackingModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [driverLocation, setDriverLocation] = useState(null);
    const [deliveryStatus, setDeliveryStatus] = useState('');
    const [isInitialRender, setIsInitialRender] = useState(true);
    const [activeTab, setActiveTab] = useState('CONFIRMED');

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const orderTypeOptions = [
        { value: null, label: 'NEW' },
        { value: 1, label: 'RETURN' },
        { value: 2, label: 'EXCHANGE' },
        { value: 3, label: 'DELIVERED' },
    ]

    const paymentModeOptions = [
        { value: "COD", label: 'COD' },
        { value: "ONLINE", label: 'ONLINE' },
    ]

    const logisticsStatusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'processing', label: 'Processing' },
        { value: 'success', label: 'Success' }
    ];

    const logisticsProviderOptions = [
        { value: 'volta', label: 'Volta' },
        { value: 'pidge', label: 'Pidge' }
    ];

    const [orderStatusOptions, setOrderStatusOptions] = useState([
        { value: 'CONFIRMED', label: 'CONFIRMED' },
        { value: 'DELIVERED', label: 'DELIVERED' }
    ]);

    const columns = [
        {
            name: "S. No.",
            selector: (row, index) => page * limit - limit + (index + 1),
            width: "90px",
            center: true, // Added
        },
        {
            id: 'orderId',
            name: 'Order Id',
            selector: (row) => row?.orderId,
            cell: (row) => (
                <Tooltip title={row?.orderId} disableInteractive placement='top'>
                    <div
                        className="related-order-box"
                        style={{
                            backgroundColor: 'rgba(70, 70, 70, 0.1)' // 50% transparent
                            ,
                            color: 'black',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            minWidth: '80px',
                            textAlign: 'center',
                            margin: '2px'
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/orderdetails/${row.id}`);
                        }}
                    >
                        {row?.orderId}
                    </div>
                </Tooltip>

            ),

            grow: 0.5,
            minWidth: '170px',
            center: true, // Added
        },
        {
            name: "Logistic Partner",
            cell: (row) => {
                const provider = row?.logisticsJobs?.[0]?.logisticsProvider?.toLowerCase();
                let bgColor = '';
                let textColor = 'white';

                if (provider === 'volta') {
                    bgColor = '#47afdcff';
                } else if (provider === 'pidge') {
                    bgColor = '#800080'; // Purple color
                } else {
                    bgColor = 'gray';
                    textColor = 'black';
                }

                return (
                    <div className="text-capitalize">
                        {provider ? (
                            <span
                                style={{
                                    backgroundColor: bgColor,
                                    color: textColor,
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    fontWeight: '500'
                                }}
                            >
                                {row.logisticsJobs[0].logisticsProvider}
                            </span>
                        ) : (
                            'N/A'
                        )}
                    </div>
                );
            },
            center: true,
            minWidth: '150px',
        },
        {
            name: "Logistics Status",
            cell: (row) => (
                <div className="text-capitalize">
                    {row?.logisticsJobs?.[0]?.status || 'N/A'}
                </div>
            ),
            center: true,
            minWidth: '150px',
        },
        {
            id: 'createdAt',
            name: 'Date',
            selector: (row) => moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a'),
            cell: (row) => (
                <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement='top'>
                    <div className='text-truncate'>{moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')}</div>
                </Tooltip>
            ),
            grow: 0.5,
            minWidth: '200px',
            center: true, // Added
        },
        {
            id: 'orderType',
            name: 'Order Type',
            selector: (row) => row?.orderType,
            cell: (row) => (
                <Tooltip title={row?.orderType === 3 ? "Delivered" : row?.orderType === 2 ? "Exchange" : row?.orderType === 1 ? "Return" : "New"} disableInteractive placement='top'>
                    <div className={`${row?.orderType == null ? "gradient-border" : "gradient-border"}`}>
                        <div className='text-truncate '>
                            {row?.orderType === 3 && <img className='order-new' src={ordernew} alt='Order New' />}
                            {row?.orderType === 2 && <img className='order-new' src={orderexchange} alt='Order Exchange' />}
                            {row?.orderType === 1 && <img className='order-new' src={orderreturn} alt='Order Return' />}
                            {row?.orderType == null && <img className='order-new' src={ordernew} alt='Order New' />}
                            {row?.orderType === 3 ? "Delivered" : row?.orderType === 2 ? "Exchange" : row?.orderType === 1 ? "Return" : "New"}
                        </div>
                    </div>
                </Tooltip>
            ),
            center: true,
            grow: 0.3,
            minWidth: '150px',
        },
        {
            id: 'amount',
            name: 'Amount',
            selector: (row) => userType === 'ADMIN' ? row?.amount : row?.billingAmount,
            cell: (row) => (
                <Tooltip title={userType === 'ADMIN' ? row?.amount : row?.billingAmount} disableInteractive placement='top'>
                    <div className='text-truncate'>{userType === 'ADMIN' ? row?.amount : row?.billingAmount}</div>
                </Tooltip>
            ),
            center: true,
            grow: 0.5,
            minWidth: '150px',
        },

        {
            name: 'Return Id',
            cell: (row) => {
                let returnIds = [];

                if (row.returnIdForVedor) {
                    if (typeof row.returnIdForVedor === 'string') {
                        returnIds = row.returnIdForVedor.split(',').map(id => id.trim());
                    } else if (Array.isArray(row.returnIdForVedor)) {
                        returnIds = row.returnIdForVedor;
                    }
                }

                return (
                    <div className="d-flex justify-content-center flex-wrap gap-1">
                        {returnIds.length > 0 ? (
                            returnIds.map((id, index) => (
                                <Tooltip
                                    key={`return-${id}-${index}`}
                                    title={`View Return Order: ${id}`}
                                    disableInteractive
                                    placement="top"
                                >
                                    <span
                                        style={{
                                            color: 'red',
                                            textDecoration: 'underline',
                                            cursor: 'pointer',
                                            fontWeight: '600',
                                            margin: '2px',
                                            fontSize: '14px'
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/orderdetails/${id}`);
                                        }}
                                    >
                                        {id}
                                    </span>
                                </Tooltip>
                            ))
                        ) : (
                            <div className="text-truncate">-</div>
                        )}
                    </div>
                );
            },
            center: true,
            minWidth: '150px',
            ignoreRowClick: true,
        },
        {
            name: 'Exchange Id',
            cell: (row) => {
                let exchangeIds = [];

                if (row.exchangeIdForVedor) {
                    if (typeof row.exchangeIdForVedor === 'string') {
                        exchangeIds = row.exchangeIdForVedor.split(',').map(id => id.trim());
                    } else if (Array.isArray(row.exchangeIdForVedor)) {
                        exchangeIds = row.exchangeIdForVedor;
                    }
                }

                return (
                    <div className="d-flex justify-content-center flex-wrap gap-1">
                        {exchangeIds.length > 0 ? (
                            exchangeIds.map((id, index) => (
                                <Tooltip
                                    key={`exchange-${id}-${index}`}
                                    title={`View Exchange Order: ${id}`}
                                    disableInteractive
                                    placement="top"
                                >
                                    <span
                                        style={{
                                            color: '#0b6a93ff',
                                            textDecoration: 'underline',
                                            cursor: 'pointer',
                                            fontWeight: '600',
                                            margin: '2px',
                                            fontSize: '14px'
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/orderdetails/${id}`);
                                        }}
                                    >
                                        {id}
                                    </span>
                                </Tooltip>
                            ))
                        ) : (
                            <div className="text-truncate">-</div>
                        )}
                    </div>
                );
            },
            center: true,
            minWidth: '150px',
            ignoreRowClick: true,
        },

        {
            name: "Payment Status",
            cell: (row) => {
                const status = row?.paymentStatus;
                let bgColor = '';
                let textColor = 'white';

                if (status === "DONE") {
                    bgColor = '#28a745'; // Green for completed
                } else {
                    bgColor = '#dc3545'; // Red for pending
                }

                return (
                    <div className="text-capitalize">
                        {status ? (
                            <span
                                style={{
                                    backgroundColor: bgColor,
                                    color: textColor,
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    fontWeight: '500'
                                }}
                            >
                                {status === "DONE" ? "Completed" : "Pending"}
                            </span>
                        ) : (
                            'N/A'
                        )}
                    </div>
                );
            },
            center: true,
            minWidth: '180px',
            sortable: true,
        },


        {
            name: "Delivery Status",
            cell: (row) => (
                <div className="text-capitalize">
                    {row?.deliveryStatus || 'N/A'}
                </div>
            ),
            center: true,
            minWidth: '150px',
        },

    ];

    const conditionalRowStyles = [

        {
            when: row => row.returnIdForVedor !== null,
            style: {
                backgroundColor: 'rgba(238, 145, 155, 0.1)', // Very light red
                '&:hover': {
                    backgroundColor: 'rgba(238, 145, 155, 0.15)' // Slightly darker on hover
                }
            },
        },
        {
            when: row => row.exchangeIdForVedor !== null,
            style: {
                backgroundColor: 'rgba(0, 140, 255, 0.1)', // Very light blue
                '&:hover': {
                    backgroundColor: 'rgba(0, 140, 255, 0.15)' // Slightly darker on hover
                }
            },
        },
        {
            when: row => row.returnIdForVedor !== null && row.exchangeIdForVedor !== null,
            style: {
                backgroundColor: 'rgba(180, 120, 255, 0.1)', // Light purple
                '&:hover': {
                    backgroundColor: 'rgba(180, 120, 255, 0.15)' // Slightly darker on hover
                }
            },
        },
    ];

    const handleOpenTrackingModal = (order) => {
        setSelectedOrder({
            ...order,

            paymentStatus: order.paymentStatus || 'PENDING',
            logisticsJobs: order.logisticsJobs || [{ status: 'pending' }],
            logisticsData: {
                ...(order.logisticsData || {}),
                currentStatus: order.logisticsData?.currentStatus || ''
            }
        });
        setShowTrackingModal(true);
    };

    const handleCloseTrackingModal = () => {
        setShowTrackingModal(false);
        setSelectedOrder(null);
        setDriverLocation(null);
    };


    const searchFormik = useFormik({
        initialValues: {
            startDate: filterData.startDate || '',
            endDate: filterData.endDate || '',
            orderType: filterData.orderType || '',
            selected_orderType: filterData.selected_orderType || '',
            paymentMode: filterData.paymentMode || '',
            selected_paymentMode: filterData.selected_paymentMode || '',
            paymentStatus: filterData.paymentStatus || '',
            selected_paymentStatus: filterData.selected_paymentStatus || ''
        },
        onSubmit: (values, { resetForm }) => {
            setLoading(true);
            setFilterdata(values);
            setShow(false);
        },
    });

    // Modify the fetchAllOrderData function to include status in the API call
    const fetchAllOrderData = async () => {
        setLoading(true);

        const params = {
            page,
            limit,
            searchQuery: search,
            status: activeTab, // Add the active tab status to the API call
            ...(filterData.startDate && { startDate: filterData.startDate }),
            ...(filterData.endDate && { endDate: filterData.endDate }),
            ...(filterData.orderType && { orderType: filterData.orderType }),
            ...(filterData.paymentMode && { paymentMode: filterData.paymentMode }),
            ...(filterData.paymentStatus && { paymentStatus: filterData.paymentStatus })
        };

        getTrackingOrdersListing(params)((response) => {
            if (response?.statusCode === 200) {
                setTotalOrdersToDownload(response?.data?.orders);
                setLimitDownloadOrders(response?.data?.totalItems);
                setOrders(response?.data?.orders);
                setTotalRows(response?.data?.totalItems || 0);
            } else {
                setTotalOrdersToDownload([]);
                setLimitDownloadOrders(5);
            }
            setLoading(false);
        });
    };

    // Add this effect to fetch data when tab changes
    useEffect(() => {
        if (!isInitialRender) {
            setPage(1); // Reset to first page when changing tabs
            fetchAllOrderData();
        }
    }, [activeTab]);


    const handleStatusChange = (field, value) => {
        setSelectedOrder(prev => {
            if (!prev) return prev;

            // Store original values when first opening modal
            const originalPaymentStatus = prev.originalPaymentStatus || prev.paymentStatus;
            const originalLogisticsStatus = prev.originalLogisticsStatus ||
                (prev.logisticsJobs?.[0]?.status || 'pending');

            // When changing ANY order to DELIVERED (works for both tabs)
            if (field === 'status' && value === 'DELIVERED') {
                return {
                    ...prev,
                    status: 'DELIVERED',
                    paymentStatus: 'DONE',
                    deliveryStatus: 'DELIVERED',
                    logisticsJobs: [{
                        ...(prev.logisticsJobs?.[0] || {}),
                        status: 'success'
                    }],
                    originalPaymentStatus,
                    originalLogisticsStatus
                };
            }

            // When changing back to CONFIRMED (from either tab)
            if (field === 'status' && value === 'CONFIRMED') {
                const shouldResetPaymentStatus = prev.paymentMode === 'COD' && prev.orderType == null;

                return {
                    ...prev,
                    status: 'CONFIRMED',
                    paymentStatus: shouldResetPaymentStatus ? 'PENDING' : originalPaymentStatus,
                    deliveryStatus: 'PENDING',
                    logisticsJobs: [{
                        ...(prev.logisticsJobs?.[0] || {}),
                        status: 'pending' // Always reset to pending when going back to CONFIRMED
                    }],
                    originalPaymentStatus: shouldResetPaymentStatus ? 'PENDING' : originalPaymentStatus,
                    originalLogisticsStatus: 'pending' // Also update the original logistics status
                };
            }

            // When changing logistics status in CONFIRMED tab
            if (field === 'logisticsStatus' && activeTab === 'CONFIRMED') {
                return {
                    ...prev,
                    logisticsJobs: [{
                        ...(prev.logisticsJobs?.[0] || {}),
                        status: value
                    }]
                };
            }

            // Only allow payment status changes if currently PENDING
            if (field === 'paymentStatus' && prev.paymentStatus === 'PENDING') {
                return {
                    ...prev,
                    paymentStatus: value,
                    originalPaymentStatus: value
                };
            }

            return prev;
        });
    };

    const handleSaveStatus = () => {
        if (!selectedOrder) return;

        setLoading(true);

        // Prepare payload
        const payload = {
            orderId: selectedOrder.id,
            orderType: selectedOrder.orderType,
            orderStatus: selectedOrder.status,
            logisticProvider: selectedOrder.logisticsJobs?.[0]?.logisticsProvider?.toLowerCase(),
            logisticsStatus: selectedOrder.logisticsJobs?.[0]?.status,
            paymentStatus: selectedOrder.paymentStatus,
            // Only include delivery status if it's being explicitly changed
            ...(selectedOrder.deliveryStatus !== selectedOrder.originalDeliveryStatus && {
                deliveryStatus: selectedOrder.deliveryStatus
            }),
            // Only include payment status if it's being explicitly changed
            ...(selectedOrder.paymentStatus !== selectedOrder.originalPaymentStatus && {
                paymentStatus: selectedOrder.paymentStatus
            })

        };

        updateTrackingStatus(payload)((response) => {
            setLoading(false);
            if (response?.success) {
                toast.success(response.message || 'Status updated successfully');
                setUpdate(!update); // Trigger refresh
                handleCloseTrackingModal();
            } else {
                toast.error(response?.error?.message || 'Failed to update status');
            }
        });
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(1);
        setUpdate(!update);
    };

    const handlePageChange = (page) => {
        setPage(page);
        setUpdate(!update);
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const deleteOrder = (id) => {
        deleteOrderItem(id)((response) => {
            if (response?.request?.status == 200) {
                setUpdate(!update);
                setModal(!modal);
            }
        });
    };

    const handleFilterChange = (filter) => {
        setPage(1);
        setFilter(filter);
    };

    const onOrderTypeChange = (selectedOption) => {
        searchFormik.setValues({
            ...searchFormik.values,
            orderType: selectedOption?.value,
            selected_orderType: selectedOption
        })
    }

    const onpaymentModeChange = (selectedOption) => {
        searchFormik.setValues({
            ...searchFormik.values,
            paymentMode: selectedOption?.value,
            selected_paymentMode: selectedOption
        })
    }

    const onpaymentStatusChange = (selectedOption) => {
        searchFormik.setValues({
            ...searchFormik.values,
            paymentStatus: selectedOption?.value,
            selected_paymentStatus: selectedOption
        })
    }

    const handleReset = () => {
        searchFormik.resetForm({
            values: {
                startDate: "",
                endDate: '',
                orderType: "",
                selected_orderType: "",
                paymentMode: "",
                selected_paymentMode: "",
                paymentStatus: "",
                selected_paymentStatus: ""
            }
        });
        setFilterdata({
            startDate: "",
            endDate: '',
            orderType: "",
            selected_orderType: "",
            paymentMode: "",
            selected_paymentMode: "",
            paymentStatus: "",
            selected_paymentStatus: ""
        });
        setSearch('');
        setShow(false);
        setUpdate(!update);
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        if (isFilterApplied) {
            searchFormik.handleSubmit(e);
        } else {
            handleReset();
        }
    };

    // Initial load effect
    useEffect(() => {
        setLoading(true);
        fetchAllOrderData(filter);
        setIsInitialRender(false);
    }, [filter, filterData]);

    // Search debounce effect (won't run on initial render)
    useEffect(() => {
        if (isInitialRender) return;

        const debounceTimer = setTimeout(() => {
            setLoading(true);
            fetchAllOrderData(filter);
        }, 500);

        return () => clearTimeout(debounceTimer);
    }, [search]);

    // Pagination effect (won't run on initial render)
    useEffect(() => {
        if (isInitialRender) return;

        setLoading(true);
        fetchAllOrderData(filter);
    }, [page, limit, update]);


    const getStatusColor = (status) => {
        switch (status) {
            case 'order_created':
                return '#33cd73ff';
            case 'admin_cancel':
                return '#dc3545'; // red (danger)
            case 'in_transit':
                return '#0d6efd'; // blue (primary)
            case 'delivered':
                return '#198754'; // green (success)
            case 'pending':
                return '#ffc107'; // yellow (warning)
            case 'failed':
                return '#6c757d'; // gray (secondary)
            default:
                return '#6f42c1'; // purple (default fallback)
        }
    };


    const isFilterApplied = !!(
        searchFormik.values.startDate ||
        searchFormik.values.endDate ||
        searchFormik.values.orderType ||
        searchFormik.values.paymentMode ||
        searchFormik.values.paymentStatus
    );

    const userType = JSON.parse(localStorage.getItem('user'))?.userType;

    return (
        <div>
            <div className="row">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-stretch mb-3">
                        <div className="d-flex align-items-center">
                            <h3 className="mb-0 fw-bolder">Order Tracking</h3>
                        </div>

                        <div className="d-flex align-items-center">
                            <div className=" d-flex align-items-center">
                                <div className="form_wrapper ">
                                    <Form className="app-search d-none d-md-block">
                                        <div className="position-relative">
                                            <Form.Control
                                                type="text"
                                                className="form-control"
                                                placeholder="Search orders using Order Id..."
                                                onChange={(e) => setSearch(e.target.value.trim())}
                                                style={{
                                                    width: "450px",
                                                    height: "46px",
                                                    padding: "14px 20px"
                                                }}
                                            />
                                            <span className="mdi mdi-magnify search-widget-icon" />
                                            <span
                                                className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                                                id="search-close-options"
                                            />
                                            <IoSearchOutline className='search_icon' />
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Add the tabs navigation */}
                    <div className="mb-4">
                        <Nav
                            variant="tabs"
                            defaultActiveKey="CONFIRMED"
                            activeKey={activeTab}
                            onSelect={setActiveTab}
                            className="mb-4 custom-order-tabs"
                        >
                            <Nav.Item>
                                <Nav.Link
                                    eventKey="CONFIRMED"
                                    className={`fs-7 fw-semibold ${activeTab === 'CONFIRMED' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                                    style={{
                                        padding: '12px 24px',

                                        backgroundColor: activeTab === 'CONFIRMED' ? '#f8f9fa' : 'transparent',
                                        transition: 'all 0.3s ease',
                                        color: activeTab === 'CONFIRMED' ? '#000' : '#6c757d'
                                    }}
                                >
                                    Confirmed Orders
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link
                                    eventKey="DELIVERED"
                                    className={`fs-7 fw-semibold ${activeTab === 'DELIVERED' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                                    style={{
                                        padding: '12px 24px',

                                        backgroundColor: activeTab === 'DELIVERED' ? '#f8f9fa' : 'transparent',
                                        transition: 'all 0.3s ease',
                                        color: activeTab === 'DELIVERED' ? '#000' : '#6c757d'
                                    }}
                                >
                                    Delivered Orders
                                </Nav.Link>
                            </Nav.Item>
                            {/* <Nav.Item>
                                <Nav.Link
                                    eventKey="CANCELLED"
                                    className={`fs-7 fw-semibold ${activeTab === 'CANCELLED' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                                    style={{
                                        padding: '12px 24px',
                                        
                                        backgroundColor: activeTab === 'CANCELLED' ? '#f8f9fa' : 'transparent',
                                        transition: 'all 0.3s ease',
                                        color: activeTab === 'CANCELLED' ? '#000' : '#6c757d'
                                    }}
                                >
                                    Cancelled Orders
                                </Nav.Link>
                            </Nav.Item> */}
                        </Nav>
                    </div>
                    <div className="d_grid_wrapper"></div>
                </div>
            </div>

            <div className='col-12'>
                <Box className="products-and-options" sx={{ mt: 1 }}>
                    <Paper square className='shadow-none border border-blue-grey-200'>
                        <div>
                            <DataTable
                                pointerOnHover // Adds cursor pointer on hover
                                highlightOnHover // Adds hover effect
                                columns={columns}
                                conditionalRowStyles={conditionalRowStyles}
                                data={orders}
                                progressPending={loading}
                                progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                paginationRowsPerPageOptions={[10, 50, 100, 150]}
                                paginationPerPage={limit}
                                onRowClicked={(row) => handleOpenTrackingModal(row)}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                currentPage={page}
                                customStyles={queueDatatableCustomStyles}
                            />
                        </div>
                    </Paper>
                </Box>
            </div>



            {/* Tracking Modal */}
            <Modal show={showTrackingModal} onHide={handleCloseTrackingModal} scrollable centered size='md'>
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="w-100 ">
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <span className="fw-bold">#{selectedOrder?.orderId}</span>

                            {/* Logistic Provider Badge */}
                            {selectedOrder?.logisticsJobs?.[0]?.logisticsProvider && (
                                <span
                                    style={{
                                        backgroundColor:
                                            selectedOrder.logisticsJobs[0].logisticsProvider.toLowerCase() === 'volta'
                                                ? '#47afdcff'
                                                : '#800080',
                                        color: 'white',
                                        padding: '2px 8px',
                                        borderRadius: '4px',
                                        fontSize: '0.8rem',
                                        fontWeight: '500',
                                    }}
                                >
                                    {selectedOrder.logisticsJobs[0].logisticsProvider}
                                </span>
                            )}


                        </div>



                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="px-4 pt-4 pb-5">
                    {selectedOrder && (
                        <div>

                            {(
                                <div className="alert alert-warning py-2 mb-0" style={{ backgroundColor: '#fce18fff', fontSize: '12px', color: 'black', }}>
                                    <span>
                                        {activeTab === 'DELIVERED' ?
                                            "Changing order status from DELIVERED to CONFIRMED will create a new order in Pidge system." :
                                            "Changing logistic status from SUCCESS to PENDING will create new order in Pidge system."
                                        }
                                    </span>
                                </div>
                            )}
                            <div className="rounded-3 bg-light p-3">

                                {/* Order Status (Always Editable) */}
                                <div className="row mb-3">
                                    <div className="col-md-12">
                                        <label className="form-label fw-medium">Order Status</label>
                                        <Select
                                            options={orderStatusOptions}
                                            value={orderStatusOptions.find(opt => opt.value === selectedOrder.status)}
                                            onChange={(selected) => handleStatusChange('status', selected.value)}
                                            isSearchable
                                            className="basic-single"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                </div>

                                {/* Logistics Section (Always Disabled) */}
                                <div className="row  mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label fw-medium">Logistic Provider</label>
                                        <Select
                                            options={logisticsProviderOptions}
                                            value={logisticsProviderOptions.find(opt =>
                                                opt.value === (selectedOrder.logisticsJobs?.[0]?.logisticsProvider?.toLowerCase() || 'pidge')
                                            )}
                                            isDisabled // Always disabled
                                            className="basic-single"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                    {/* Logistics Status (Always Disabled - Just Shows Value) */}
                                    <div className="col-md-6">
                                        <label className="form-label fw-medium">Logistics Status</label>
                                        <Select
                                            options={logisticsStatusOptions}
                                            value={logisticsStatusOptions.find(opt =>
                                                opt.value === (selectedOrder.logisticsJobs?.[0]?.status || 'pending')
                                            )}
                                            onChange={(selected) => handleStatusChange('logisticsStatus', selected.value)}
                                            isDisabled={activeTab === 'DELIVERED' || (activeTab === 'CONFIRMED' && selectedOrder.status === 'DELIVERED')} // Only disabled for DELIVERED tab
                                            className="basic-single"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                </div>

                                {/* Payment Status (Editable only if PENDING) */}
                                <div className="row mb-0">
                                    <div className="col-md-6">

                                        <div className="d-flex justify-content-start align-items-center" style={{ width: 'fit-content' }}>
                                            <label className="form-label fw-medium" style={{ fontSize: '0.8rem', marginRight: '6px' }}>
                                                Payment Status
                                            </label>
                                            <span
                                                style={{
                                                    backgroundColor: selectedOrder.paymentMode === 'ONLINE' ? '#28a745' : '#d76f00ff',
                                                    color: 'white',
                                                    padding: '1px 5px 1px 4px',
                                                    borderRadius: '3px',
                                                    fontSize: '0.55rem',
                                                    fontWeight: '500',
                                                    textTransform: 'uppercase',
                                                    lineHeight: '1.15',
                                                    letterSpacing: '0.3px'
                                                }}
                                            >
                                                {selectedOrder.paymentMode}
                                            </span>
                                        </div>


                                        <Select
                                            options={paymentStatusOptions}
                                            value={paymentStatusOptions.find(opt => opt.value === selectedOrder.paymentStatus)}
                                            onChange={(selected) => handleStatusChange('paymentStatus', selected.value)}
                                            isSearchable
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isDisabled // Only editable if pending
                                        />
                                    </div>

                                    {/* Delivery Status (Always Disabled) */}
                                    <div className="col-md-6">
                                        <label className="form-label fw-medium">Delivery Status</label>
                                        <Select
                                            options={deliveryStatusOptions}
                                            value={deliveryStatusOptions.find(opt => opt.value === selectedOrder.deliveryStatus)}
                                            isDisabled // Always disabled
                                            className="basic-single"
                                            classNamePrefix="select"
                                        />
                                    </div>
                                </div>


                            </div>

                        </div>

                    )}
                </Modal.Body>

                <Modal.Footer className="border-0 pt-0">
                    <div className="d-flex justify-content-end w-100 gap-3">
                        <Button variant="outline-secondary" className='cancel_btn' onClick={handleCloseTrackingModal}>
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            onClick={handleSaveStatus}
                            disabled={loading}
                            className='request_btn'
                        >
                            {loading ? <><Spinner size="sm" /> saving</> : 'Save Changes'}
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            <CustomisedModal
                isOpen={modal}
                customClass={"policy_modal"}
                toggle={toggleModal}
            >
                <h5>Are you sure you want to remove this item?</h5>
                <div className="policy_Agree">
                    <Button
                        onClick={() => {
                            setModal(!modal);
                        }}
                        size="lg"
                        className="btn_cancel"
                    >
                        Cancel
                    </Button>
                    <Button
                        size="lg"
                        className="btn"
                        onClick={() => deleteOrder(deletingId)}
                    >
                        Delete
                    </Button>
                </div>
            </CustomisedModal>
        </div>
    )
}

export default Tracking;